import enLabels from '@/locales/en.json'

type Labels = typeof enLabels

export function useLabels(): Labels {
  // In the future, this could be expanded to support multiple languages
  return enLabels
} 